/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ShardPressureDto
 */
export interface ShardPressureDto {
    /**
     * 
     * @type {number}
     * @memberof ShardPressureDto
     */
    shardIndex?: number;
    /**
     * 
     * @type {string}
     * @memberof ShardPressureDto
     */
    ingestTaskQueue?: string;
    /**
     * 
     * @type {number}
     * @memberof ShardPressureDto
     */
    runningExecutions?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ShardPressureDto
     */
    atAdmissionCapacity?: boolean;
}

/**
 * Check if a given object implements the ShardPressureDto interface.
 */
export function instanceOfShardPressureDto(value: object): value is ShardPressureDto {
    return true;
}

export function ShardPressureDtoFromJSON(json: any): ShardPressureDto {
    return ShardPressureDtoFromJSONTyped(json, false);
}

export function ShardPressureDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShardPressureDto {
    if (json == null) {
        return json;
    }
    return {
        
        'shardIndex': json['shardIndex'] == null ? undefined : json['shardIndex'],
        'ingestTaskQueue': json['ingestTaskQueue'] == null ? undefined : json['ingestTaskQueue'],
        'runningExecutions': json['runningExecutions'] == null ? undefined : json['runningExecutions'],
        'atAdmissionCapacity': json['atAdmissionCapacity'] == null ? undefined : json['atAdmissionCapacity'],
    };
}

export function ShardPressureDtoToJSON(json: any): ShardPressureDto {
    return ShardPressureDtoToJSONTyped(json, false);
}

export function ShardPressureDtoToJSONTyped(value?: ShardPressureDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'shardIndex': value['shardIndex'],
        'ingestTaskQueue': value['ingestTaskQueue'],
        'runningExecutions': value['runningExecutions'],
        'atAdmissionCapacity': value['atAdmissionCapacity'],
    };
}

